export default __webpack_public_path__ + "static/media/22.7e8113f6.jpg";